import React from "react";
import socketIOClient from "socket.io-client";
import './App.css';
import Game from './Game'
import { connect } from 'react-redux'

import logo from "./static/logo.png";

import { 
        socket, 
        joinGame,
        rejoinGame,
        updatePlayers,
        startGame,
        leaveGame,
        updateGame,
        updateGamesList,
        updateLawChoices,
        resetGame,
        setPeekCards,
        updateVotes,
        playerInvestigated,
        openGameLobby
      } from './actions';

class App extends React.Component {

  constructor(props) {
    super(props)

    this.gameNameRef = React.createRef();
    this.nameRef = React.createRef();
    this.passwordRef = React.createRef();

    socket.on("players updated", (players) => this.props.updatePlayers(players));
    socket.on("update games list", (games) => {
      this.props.updateGamesList(games);
    });
    socket.on("game updated", (data) => this.props.updateGame(data));
    socket.on("start game", (data) => { this.props.startGame(data) });
    socket.on("laws", (laws) => this.props.updateLawChoices(laws));
    socket.on("messages", (messages) => { console.log(messages) });
    socket.on("reset game", (data) => this.props.resetGame());
    socket.on("votes", (votes) => { this.props.updateVotes(votes); });
    socket.on("peek", (data) => this.props.setPeekCards(data));
    socket.on("investigated player", (player) => { this.props.playerInvestigated(player); });

    if (localStorage.getItem('playerKey') !== null && localStorage.getItem("gameName") !== null) { 
      this.props.rejoinGame(localStorage.getItem('playerKey'), localStorage.getItem("gameName"), this.props.leaveGame); 
    } else { 
      socket.emit("get games");
    }
  }

  render() {

    return (
      <React.Fragment>

       { /* ACCESS NOT YET ATTEMPTED - LANDING PAGE - LIST OF GAMES */}
        {this.props.game === undefined &&
          <div
            className="center"
            style={{
              position: 'absolute',
              top: 0, bottom: 0, left: 0, right: 0,
              padding: '5% 0%',
            }}
          >
            <img src={logo} style={{ width: 400, marginBottom: 50 }} onClick={() => {window.location.reload()}}/>

              {Object.keys(this.props.games).length !== 0  && 
                <React.Fragment>
                  <p style={{ fontSize: 40, marginBottom: 20, userSelect: "none" }} className="headerText" >
                    JOIN GAME
                  </p>
                  <div style={{ overflowX : "auto", border: '3px solid black', borderRadius: '3px' }}>
                    <table className="gamesTable" style={{ height: 180, width: 400, marginTop: 0 }}>
                      <tbody>
                        {Object.keys(this.props.games).map((name) => {
                          var game = this.props.games[name];
                          game.gameName = name;
                          return (
                            <tr key={name} onClick={ () => { this.props.openGameLobby(game); } }>
                              <td style={{ textAlign: 'left' }}> {name} {game.requires_password ? " 🔒" : ""} </td>
                              <td style={{ textAlign: 'right' }}> {game.num_players}{game.num_players === 1 ? " player":" players"} </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </React.Fragment>
              }
              <div>
                <p
                  style={{ fontSize: 40, marginTop: 100 }} className="clickable headerText"
                  onClick={() => { 
                    // createGame
                    this.props.openGameLobby({});
                  }}
                >
                  CREATE NEW GAME
                </p>
                <button type="submit" style={{ "display": "none" }} />
              </div>
          </div>
        }

        { /* LOGGING INTO A GAME  */}
        {this.props.game !== undefined && this.props.access === undefined &&
          <div
            className="center"
            style={{
              position: 'absolute',
              top: 0, bottom: 0, left: 0, right: 0,
              padding: '5% 0%',
            }}
          >
            <img src={logo} style={{ width: 400, marginBottom: 50 }} onClick={() => {window.location.reload()}}/>
            <form className="center" onSubmit={(e) => {
              e.preventDefault();
              this.props.joinGame(
                this.nameRef.current ? this.nameRef.current.value: undefined, 
                this.gameNameRef.current ? this.gameNameRef.current.value : this.props.game.gameName,
                this.passwordRef.current ? this.passwordRef.current.value : undefined, 
                this.props.game.gameName === undefined 
              )
            }}>
              <label className="center">
                <input required type="text" placeholder="Your Name" ref={this.nameRef} />
                { this.props.game.gameName === undefined && (
                  <React.Fragment>
                    <input required type="text" placeholder="Your Game Name" ref={this.gameNameRef} />
                    <input type="text" placeholder="Passcode (optional)" ref={this.passwordRef} />
                  </React.Fragment>
                )}
                { this.props.game.requires_password && <input required type="text" name="password" placeholder="The Passcode" ref={this.passwordRef} />}
              </label>
              {this.props.serverError && 
                <p style={{ fontSize: 20, color: 'black' }} className="headerText">
                  { this.props.serverError } 
                </p>
              }
              <div>
                  {this.props.game.gameName && 
                    <button type="submit" className="headerTextButton clickable">
                      JOIN { this.props.game.gameName }
                    </button>
                  }
                  {!this.props.game.gameName && 
                    <button type="submit" className="headerTextButton clickable">
                      CREATE GAME
                    </button>
                  }
              </div>
            </form>
          </div>
        }

        { /* ACCESS DENIED */}
        {this.props.game !== undefined && this.props.access === "denied" &&
          <div
            className="center"
            style={{
              position: 'absolute',
              top: 0, bottom: 0, left: 0, right: 0,
              padding: '5% 0%',
            }}
          >
            <p
              style={{ fontSize: 40 }} className="clickable headerText"
              onClick={this.props.leaveGame}
            >
              ACCESS DENIED
              </p>
          </div>
        }

        { /* ACCESS GRANTED - IN LOBBY */}
        {this.props.game !== undefined && !this.props.activeGame && this.props.access === "granted" &&
          <React.Fragment>
            <div className="header">
              <img src={logo} style={{ width: 100 }} />
              <p
                style={{ fontSize: 30 }} className="clickable headerText"
                onClick={this.props.leaveGame}
              >
                LEAVE GAME
                </p>
            </div>
            <div
              className="center"
              style={{
                position: 'absolute',
                top: 0, bottom: 0, left: 0, right: 0,
                padding: '5% 0%',
              }}
            >
              <p style={{ fontSize: 40 }} className="headerText">
                ACCESS GRANTED: { this.props.game.gameName }
              </p>

              <table className="playerTable" style={{ height: 400, width: 400, marginTop: 0 }}>
                <tbody>
                  {Object.keys(this.props.players).map((playerID) => {
                    var player = this.props.players[playerID];
                    return (
                      <tr key={player.id}>
                        <td style={{ textAlign: 'center', fontSize: 22 }}> {player.name} </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>

              <div>
                {((Object.keys(this.props.players).length >= 5 && Object.keys(this.props.players).length <= 10)) && (<p
                  style={{ fontSize: 40, textAlign: 'center' }} className="clickable headerText"
                  onClick={() => { socket.emit("ready up"); }}
                >
                  WE'RE ALL READY
                </p>)
                }

                {(Object.keys(this.props.players).length < 5 || Object.keys(this.props.players).length > 10) && (<p
                  style={{ fontSize: 40, textAlign: 'center' }} className="headerText"
                >
                  WAITING FOR 5-10 PLAYERS
                </p>)
                }
              </div>
            </div>
          </React.Fragment>
        }

        { /* ACCESS GRANTED, ACTIVE GAME */}
        {this.props.game !== undefined && this.props.activeGame === true && this.props.access === "granted" &&
          <React.Fragment>
            <div className="header">
              <img src={logo} style={{ width: 100 }} />
                <p
                  style={{ fontSize: 30 }} className="clickable headerText"
                  onClick={() => { socket.emit("reset game") }}
                >
                END GAME
                </p>
            </div>
            <Game />
          </React.Fragment>
        }

      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    access: state.access,
    playerID: state.playerID,
    players: state.players,
    activeGame: state.activeGame,
    games: state.games,
    game: state.game,
    serverError: state.serverError,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateGamesList: (games) => dispatch(updateGamesList(games)),
    openGameLobby: (game) => dispatch(openGameLobby(game)),
    joinGame: (name, gameName, password, create) => dispatch(joinGame(name, gameName, password, create)),
    rejoinGame: (playerKey, gameName, onError) => dispatch(rejoinGame(playerKey, gameName, onError)),
    updatePlayers: (players) => dispatch(updatePlayers(players)),
    startGame: (data) => dispatch(startGame(data)),
    updateGame: (data) => dispatch(updateGame(data)),
    leaveGame: () => {
      dispatch(leaveGame())
      socket.emit("get games");
    },
    updateLawChoices: (laws) => dispatch(updateLawChoices(laws)),
    resetGame: () => dispatch(resetGame()),
    setPeekCards: (data) => dispatch(setPeekCards(data)),
    updateVotes: (data) => dispatch(updateVotes(data)),
    playerInvestigated: (data) => dispatch(playerInvestigated(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)